import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-54943459"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "address-block__content col-lg-6 pe-lg-5" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<div class=\"address-block__content--wrapper\" data-v-54943459><h2 data-v-54943459><span class=\"d-block text-primary\" data-v-54943459>Bolton</span></h2><p class=\"line-two\" data-v-54943459><a href=\"tel:01204699566\" data-v-54943459>+44 (0)1204 699566</a></p><div class=\"address-block__leadin mt-3 mb-3\" data-v-54943459><p data-v-54943459>Rugby House, Hampson Street<br data-v-54943459>Horwich, BL6 7JH</p></div><div class=\"cta\" data-v-54943459><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.google.com/maps/place/Absolute+Agency/@53.6019841,-2.5528742,15z/data=!4m2!3m1!1s0x0:0xf15fcf9c86cbd73d?sa=X&amp;ved=1t:2428&amp;ictx=111\" class=\"cta-link\" data-v-54943459>Find Us</a></div></div><div class=\"address-block__content--wrapper mt-5 pt-2\" data-v-54943459><h2 data-v-54943459><span class=\"d-block text-primary\" data-v-54943459>London</span></h2><p class=\"line-two\" data-v-54943459><a href=\"tel:02045388086\" data-v-54943459>+44 (0)20 4538 8086</a></p><div class=\"address-block__leadin mt-3 mb-3\" data-v-54943459><p data-v-54943459>3rd Floor, 86-90 Paul Street<br data-v-54943459>London, EC2A 4NE</p></div><div class=\"cta\" data-v-54943459><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.google.com/maps/place/3rd+Floor,+86+-+90+Paul+St,+London+EC2A+4NE/data=!4m2!3m1!1s0x48761ca55fd39f3d:0x85fd82cf3d59855?sa=X&amp;ved=1t:242&amp;ictx=111\" class=\"cta-link\" data-v-54943459>Find Us</a></div></div>", 2);
const _hoisted_6 = {
    key: 0,
    src: "/assets/site/content/contact/address-block.png",
    class: "img-fluid mt-4 mb-4",
    loading: "lazy"
};
const _hoisted_7 = {
    key: 0,
    class: "address-block__images col-lg-6 ps-lg-5"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: "/assets/site/content/contact/address-block.png",
    class: "img-fluid",
    loading: "lazy"
}, null, -1));
const _hoisted_9 = [
    _hoisted_8
];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'address_block',
    props: ['d'],
    setup(__props) {
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 992);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 992;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: "address-block right",
                style: _normalizeStyle(`background: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            (isMobile.value)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                                : _createCommentVNode("", true)
                        ]),
                        (!isMobile.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 4));
        };
    }
});
